import axios from 'axios';
import Constants from '../constants';
import { ISurveyQuestionEditModel } from '../models';

export const updateSurveyQuestions = async (
	surveyId: number,
	surveyQuestionEditModels: ISurveyQuestionEditModel[],
): Promise<ISurveyQuestionEditModel[]> => {
	const url = Constants.API_SURVEY_QUESTION_EDIT_MODELS_URL.replace('{surveyId}', surveyId.toString());
	const response = await axios.put<ISurveyQuestionEditModel[]>(url, surveyQuestionEditModels, {
		headers: { 'Content-Type': 'application/json' },
	});
	return response.data;
};
